module.exports = __webpack_public_path__ + "static/media/senior_65.d6ef3321.png";